export default "__VITE_PUBLIC_ASSET__f8688b8c__"